import { observer } from "mobx-react-lite";
import { FC } from "react";
import styled from "@emotion/styled";
import { MdsCardKind } from "@/design-system/components/card/types";
import { OAuthCardWrapper } from "@/pages/oauth-consent/oauth-card-wrapper";

export interface OAuthCardErrorProps {}

export const OAuthCardError: FC<OAuthCardErrorProps> = observer(() => {
  return (
    <OAuthCardWrapper kind={MdsCardKind.LargeShadow}>
      <TitleSection>Something went wrong.</TitleSection>
    </OAuthCardWrapper>
  );
});

const TitleSection = styled.div`
  color: ${({ theme }) => theme.colors.grey.x600};
  font-size: ${({ theme }) => theme.fontSizes.xlarge};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  letter-spacing: ${({ theme }) => theme.lineSpacings.large};
  margin-bottom: 28px;
`;
